<template>
  <div ref="listContainer" @scroll="onScroll" class="membresBox" :class="{ largeMode: largeMode }">
    <LargeProfileBox
      v-for="(result, index) in scrollableList.result.list"
      :result="result"
      :key="index"
      :index="index"
      :deleteButton="deleteButton"
      :updateStatus="updateStatus"
      @onDelete="onDelete"
    />
    <div v-if="!$store.state.loading && scrollableList.result.list.length == 0">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import LargeProfileBox from "@/components/membres/LargeProfileBox";
import { ScrollableList } from "@/assets/js/scrollableList.js";
import Vue from "vue";

export default {
  name: "Membres",
  components: { LargeProfileBox },
  props: {
    pattern: {
      type: Object,
      default: null
    },
    updateStatus: {
      type: Boolean,
      default: false
    },
    save: {
      type: Boolean,
      default: false
    },
    deleteButton: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      scrollableList: null
    };
  },

  computed: {
    largeMode() {
      return this.$store.state.user.listType == 0;
    },

    resultsList: function() {
      return this.scrollableList.result.list;
    },

    noResults: function() {
      return (
        this.$parent.initiated && this.$store.state.loading === false && this.scrollableList.result.list.length === 0
      );
    }
  },

  created: function() {
    this.scrollableList = new ScrollableList(this.loadFromApi);
  },

  methods: {
    loadFromApi: function(list) {
      this.pattern.pageNumber = list.result.currentPage;
      return idyuJsonRpc("doSearch", this.pattern, this.save);
    },

    onScroll: function() {
      this.scrollableList.onScroll(this.$refs.listContainer, this.$store);
    },

    init: async function() {
      this.$store.commit("setLoading", true);
      this.scrollableList = new ScrollableList(this.loadFromApi);
      await this.$global.pageInitiated;
      await this.scrollableList.loadUntilScroll(this.$refs.listContainer);
      await Vue.nextTick();
      this.$store.commit("setLoading", false);
    },

    onDelete: function(result, index) {
      this.$emit("onDelete", result, index);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.membresBox {
  padding-left: $content_margins;
  padding-right: $content_margins;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-rows: min-content;
  grid-gap: $content_margins;
  overflow-y: scroll;
  position: absolute;
  top: 40px;
  bottom: 0;
  left: 0;
  right: 0;
}

@media screen and (max-width: 865px) {
  .membresBox {
    grid-template-columns: auto;
    padding-left: $content_margins_small;
    padding-right: $content_margins_small;
  }
}

@media screen and (min-width: 800px) {
  .largeMode.membresBox {
    grid-template-columns: auto;
  }
}
</style>
